import React from 'react';
import { ACCOUNTS } from '../mockData';

const AccountManagement = () => {
    return (
        <div className="account-management">
            <div className="data-table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Họ tên</th>
                            <th>Email</th>
                            {/* <th>Vai trò</th> */}
                            {/* <th>Trạng thái</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {ACCOUNTS.map((account) => (
                            <tr key={account.id}>
                                <td>{account.id}</td>
                                <td>{account.name}</td>
                                <td>{account.email}</td>
                                {/* <td>{account.role}</td> */}
                                {/* <td>
                                    <span className={`status-badge ${account.status === 'Active' ? 'status-active' : 'status-expired'}`}>
                                        {account.status}
                                    </span>
                                </td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AccountManagement;
